export default __webpack_public_path__ + "static/media/logo-horizontal-white.9565240a.png";